export default __webpack_public_path__ + "static/media/langchain_hexagon.8d29ce3a.svg";